import React from 'react'
import Image from 'gatsby-image'
import { graphql, StaticQuery } from 'gatsby'
import BeautyConsulting from '../../resources/assets/images/new-logo-consultoria-de-belleza@2x.png'
import { Image as ImageWeb } from '@naturacosmeticos/natds-web'

const logoImageQuery = graphql`
  query {
    logoImage: file(relativePath: { eq: "logo.png" }) {
      ...logoImageSize
    }
  }
`

const logoImage = data => {
  return (
    <Image
      alt="Logotipo da Natura"
      fixed={data.logoImage.childImageSharp.fixed}
    />
  )}

const LogoStaticQuery = ({ render}) => {
  return(
    <StaticQuery render={render} query={logoImageQuery} />
  )}
const Logo = () => <LogoStaticQuery render={logoImage} />

export const LogoBeautyConsulting = () =>  {
  return (<ImageWeb
    alt="Logotipo da Natura"
    style={{width: 150, height: 40 , marginTop: '6.5px' }}
    src={BeautyConsulting}
  />)
}


export default Logo

export const logoImageSize = graphql`
  fragment logoImageSize on File {
    childImageSharp {
      fixed(width: 62, height: 53, quality: 100) {
        ...GatsbyImageSharpFixed_withWebp
      }
    }
  }
`
